import ApplicationDetailsLayout from "core/layouts/components/application-details-layout/ApplicationDetailsLayout";
import ApplicationStepsLayout from "core/layouts/components/application-steps-layout/ApplicationStepsLayout";
import { Navigate, RouteObject } from "react-router-dom";

import ApplicationsResolver from "../protected-routes/applications-resolver/ApplicationsResolver";
import { applicationDetailsRoutes } from "./applicationDetailsRoutes";
import { applicationStepsRoutes } from "./applicationStepsRoutes";
import ApplicationPaymentLayout from "core/layouts/components/application-payment-layout/ApplicationPaymentLayout";
import ApplicationsPaymentResolver from "../protected-routes/applications-resolver/ApplicationsPaymentResolver";
import { applicationPaymentRoutes } from "./applicationPaymentRoutes";

export const applicationRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate replace to="/404" />,
  },
  {
    path: 'step',
    element: (
      <ApplicationsResolver>
        <ApplicationStepsLayout />
      </ApplicationsResolver>
    ),
    children: applicationStepsRoutes,
  },
  {
    path: 'payment',
    element: (
      <ApplicationsPaymentResolver>
        <ApplicationPaymentLayout />
      </ApplicationsPaymentResolver>
    ),
    children: applicationPaymentRoutes,
  },
  {
    path: 'details',
    element: (
      <ApplicationsResolver>
        <ApplicationDetailsLayout />
      </ApplicationsResolver>
    ),
    children: applicationDetailsRoutes,
  },
];
